import CryptoJS from 'crypto-js'

export const saveToken = (token) => {
  localStorage.token = token
}

export const saveUserData = (object) => {
  var enc = CryptoJS.AES.encrypt(JSON.stringify(object), 'un112233!!').toString()
  localStorage.setItem('uData', enc)
}

export const getUserData = (key) => {
  let data = localStorage.getItem('uData')
  if (data) {
    let bytes = CryptoJS.AES.decrypt(data, 'un112233!!')
    let json = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    if (json) {
      if (key) {
        if (key === 'role') {
          return json.okta && json.okta.type ? json.okta.type.name : ''
        }
      }
      return json
    }
    return ''
  }
}

export const saveFeatureData = (object) => {
  localStorage.setItem('all_features', JSON.stringify(object))
}

export const saveUserClientData = (object) => {
  var enc = CryptoJS.AES.encrypt(JSON.stringify(object), 'un112233!!').toString()
  localStorage.setItem('cData', enc)
}
export const getUserClientData = (key) => {
  let data = localStorage.getItem('cData')
  if (data) {
    let bytes = CryptoJS.AES.decrypt(data, 'un112233!!')
    let json = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    if (json) {
      if (key) {
        return json[key]
      }
      return json
    }
    return ''
  }
}
export const logOut = () => {
  localStorage.clear()
}
export const isLoggedIn = () => {
  if (localStorage.getItem('token')) {
    return true
  }

  return false
}

export const getToken = () => {
  if (isLoggedIn()) {
    return 'Bearer ' + localStorage.getItem('token')
  }
  return ''
}
export const saveAccount = (accountId) => {
  localStorage.account_id = accountId
}
export const saveAccountName = (name) => {
  localStorage.setItem('account_name', name)
}
export const saveAccountShowDepartmentsFlag = (flag) => {
  localStorage.setItem('account_show_departments', flag)
}

export const getAccountName = () => {
  return localStorage.getItem('account_name')
}

export const getAccountShowDepartmentsFlag = () => {
  return localStorage.getItem('account_show_departments')
}

export const getAccountId = () => {
  let accountId = localStorage.getItem('account_id')
  if (accountId && accountId !== 'null') {
    return accountId
  }
  return false
}

export const isAdmin = () => {
  return getUserData('role') === 'Admin'
}

export const loadAptrinsic = (id, email, firstName, lastName, clientId, clientName) => {
  aptrinsic('identify',
    {
      // User Fields
      'id': id, //  Required for logged in app users
      'email': email,
      'firstName': firstName,
      'lastName': lastName,
      'signUpDate': '', // unix time in ms
      'plan': '', // Custom attributes - please create those custom attributes in Aptrinsic via Account Settings to be tracked.
      'price': 500,
      'userHash': '' // optional transient for HMAC identification
    },
    {
      // Account Fields
      'id': clientId, // Required
      'name': clientName,
      'Program': '' // flat custom attributes
    })
}



// WEBPACK FOOTER //
// ./src/service/auth.js